export default "__VITE_ASSET__256c3a18__"